import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "button"];

  connect() {
    this.toggle();
  }

  toggle() {
    this.buttonTarget.classList.toggle("d-none", this.inputTarget.value.length === 0);
  }

  clear(event) {
    event.preventDefault();
    this.inputTarget.value = "";
    this.inputTarget.dispatchEvent(new Event("input", {bubbles: true}));
    this.inputTarget.focus();
  }

  keepDigitsOnly(event) {
    event.preventDefault();
    this.inputTarget.value = this.inputTarget.value.replace(/\D/g, "");
    this.inputTarget.dispatchEvent(new Event("input", {bubbles: true}));
    this.inputTarget.focus();
  }
}
